module.exports = __webpack_public_path__ + "img/Upmood_Illustration_1_x1.36a05e99.png";